﻿<template>
    <div class="ao-select">
        <fieldset class="ao-pax">
            <legend>Who is joining?</legend>
            <label v-for="(passenger, index) in passengers" :key="index" class="ao-pax-chip" :class="{ 'is-checked': checkTickBox(Passenger_Selected(index)) }" :for="Control_Name(index)">
                <input :id="Control_Name(index)" type="checkbox" :checked="checkTickBox(Passenger_Selected(index))" :disabled="Addon_In_Basket()" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded" @change="Toggle_Passenger(index)">
                <span>{{passenger.first_name || ('Passenger ' + (index + 1))}}</span>
                <small>{{Get_Price(passenger)}}</small>
            </label>
        </fieldset>

        <div class="ao-add">
            <span v-if="!Addon_In_Basket() && selected_passengers.length > 0" class="ao-add-total">
                {{ selected_passengers.length === 1 ? '1 passenger' : selected_passengers.length + ' passengers' }}
            </span>
            <button v-if="Addon_In_Basket() && !addingAddon" type="button" class="ao-added" disabled>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                Added to cart
            </button>
            <button v-else type="button" class="button button-pink-book small ao-add-btn" :disabled="addingAddon || selected_passengers.length == 0" :title="selected_passengers.length == 0 ? 'Select at least one passenger' : ''" @click="add_AddOn()">
                <svg v-if="addingAddon" class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                {{ addingAddon ? 'Adding…' : 'Add to trip' }}
            </button>
        </div>
    </div>
</template>

<script lang="ts" src="./select_passengers.ts"></script>